import parkplusStoreV2Reducer from './reducer';

export function getParkPlusStoreV2Module() {
  return {
    // Unique id of the module
    id: 'parkplusStoreV2',
    // Maps the Store key to the reducer
    reducerMap: {
      parkplusStoreV2: parkplusStoreV2Reducer,
    },
  };
}
